import { render, staticRenderFns } from "./DeliveryTab.vue?vue&type=template&id=5131cf5b&"
import script from "./DeliveryTab.vue?vue&type=script&lang=js&"
export * from "./DeliveryTab.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports